import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { User } from '../../../../auth/models';
import { FormValidationErrorsHelper } from '../../../../common/helpers/forms/form-validation-errors-helper';
import { PaymentTypesCollection } from '../../../../common/models/payment-type';
import { ToastService } from '../../../../main/services';
import { tenderAnalyticsCostOfCapitalForm } from '../../../forms';
import { CostOfCapital } from '../../../models';
import { TenderAnalyticsSettingsService } from '../../../services';

@Component({
    selector: 'jft-tender-cost-of-capital',
    templateUrl: './cost-of-capital.component.html',
    styleUrls: ['cost-of-capital.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CostOfCapitalComponent implements OnInit {

    public form: UntypedFormGroup;
    public costOfCapital: CostOfCapital;
    public paymentTypesCollection: PaymentTypesCollection;
    public loading: boolean = false;
    public tenderId: string;

    constructor(
        protected route: ActivatedRoute,
        private service: TenderAnalyticsSettingsService,
        private toast: ToastService,
        public user: User
    ) {

    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.tenderId = this.route.snapshot.parent.parent.params.id;
        this.costOfCapital = data['cost_of_capital'];

        this.initForm();

        // Tender Settings are read-only for non-Manager roles.
        if (!this.user.canManageAdvanced()) {
            this.form.disable();
        }
    }

    public initForm() {
        this.form = tenderAnalyticsCostOfCapitalForm(this.costOfCapital);
    }

    public save() {
        if (this.form.invalid === true) {
            this.toast.error('Invalid data');
            return;
        }
        this.form.disable();
        this.loading = true;

        this.service.saveCostOfCapital(this.form.value, this.tenderId)
            .pipe(finalize(() => this.form.enable()))
            .subscribe(
            data => {
                this.toast.success(`WACC value has been updated`);
                this.loading = false;
            },
            err => {
                this.form.enable();
                //this.toast.error(err)
            });
    }

    public getFirstFormGroupErrorLabel(form: UntypedFormGroup) {
        let formValidationErrors = new FormValidationErrorsHelper();
        return formValidationErrors.getFirstErrorFormLabel(form);
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return {
            'is-invalid': control.invalid && control.touched
        };
    }
}
